import React, { useState } from "react";
import axios from "axios";
import { Button, Col, Container, Row } from "react-bootstrap";

import File, { FilesContainer, RemoveButton } from "../../common/components/File";
import FloatingLabelInput from "../../common/components/FloatingLabelInput";
import UploadBox from "../../common/components/UploadBox";

const OcrUserImport = ({ slug }) => {
  const [state, setState] = useState({
    files: [],
    loading: false,
    userData: {},
  });
  const isUserDataPresent = Object.values(state.userData).some(value => !!value);

  const onNewFile = (file) => {
    setState({ ...state, files: [...state.files, file] });
  };

  const removeFileAt = (idx) => {
    setState({ ...state, files: state.files.filter((_, i) => i !== idx) });
  };

  const handleUserDataChange = (field) => (e) => {
    setState({
      ...state,
      userData: {
        ...state.userData,
        [field]: e.target.value
      }
    });
  };

  const handleScan = async () => {
    setState({ ...state, loading: true });
    try {
      const formData = new FormData();
      state.files.forEach((file) => {
        formData.append("documents[]", file);
      });

      const response = await axios.post(`/test_groups/${slug}/ocr_scan_user_import_documents`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      setState({ ...state, loading: false, userData: response.data.user_data });
    } catch (error) {
      setState({ ...state, loading: false });
      toastr.error(error.message);
    }
  };

  const handleSaveUser = async () => {
    setState({ ...state, loading: true });
    try {
      const apiData = {
        test_group_id: slug,
        user: {
          ...state.userData,
          source: 'ocr_import'
        }
      };

      const response = await axios.post('/api/test_group_users.json', apiData);
      const testGroupUserId = response.data.id;
      // Redirect to the review page
      window.location.href = `/test_groups/${slug}/schools/student_uploads/${testGroupUserId}/review`;
    } catch (error) {
      setState({ ...state, loading: false });
      toastr.error(error.response?.data?.errors?.join(', ') || error.message);
    }
  };

  const fileUploader = (
    <>
      <div className="my-3">
        <UploadBox onChange={onNewFile} style={{ minHeight: 230 }} />
        {state.files.length > 0 && (
          <FilesContainer className="mt-4">
            {state.files.map((file, idx) => (
              <File
                key={idx}
                file={file}
                actions={[
                  <RemoveButton onClick={() => removeFileAt(idx)} />,
                ]}
              />
            ))}
          </FilesContainer>
        )}
      </div>
      {!!state.files.length && (
        <div className="d-flex justify-content-end">
          <Button
            className="my-3"
            onClick={handleScan}
            disabled={state.loading}
          >
            {state.loading ? "Scanning..." : "Scan"}
          </Button>
        </div>
      )}
    </>
  );

  const userFields = (
    <>
      <Row>
        <Col>
          <div className="my-3">
            <FloatingLabelInput
              label="First name"
              value={state.userData["first_name"]}
              onChange={handleUserDataChange("first_name")}
              className="my-3"
            />
          </div>
        </Col>
        <Col>
          <div className="my-3">
            <FloatingLabelInput
              label="Last name"
              value={state.userData["last_name"]}
              onChange={handleUserDataChange("last_name")}
            />
          </div>
        </Col>
      </Row>
      <Row>
        <Col>
          <div className="my-3">
            <FloatingLabelInput
              label="Date of birth"
              value={state.userData["date_of_birth"]}
              onChange={handleUserDataChange("date_of_birth")}
            />
          </div>
        </Col>
        <Col>
          <div className="my-3">
            <FloatingLabelInput
              label="Gender"
              value={state.userData["gender"]}
              onChange={handleUserDataChange("gender")}
            />
          </div>
        </Col>
      </Row>
      <Row>
        <Col>
          <div className="my-3">
            <FloatingLabelInput
              label="Phone"
              value={state.userData["phone_number"]}
              onChange={handleUserDataChange("phone_number")}
            />
          </div>
        </Col>
        <Col>
          <div className="my-3">
            <FloatingLabelInput
              label="Email"
              value={state.userData["email"]}
              onChange={handleUserDataChange("email")}
            />
          </div>
        </Col>
      </Row>
      <Row>
        <Col>
          <div className="my-3">
            <FloatingLabelInput
              label="Ethnicity"
              value={state.userData["ethnicity"]}
              onChange={handleUserDataChange("ethnicity")}
            />
          </div>
        </Col>
      </Row>
      <Row>
        <Col>
          <div className="my-3">
            <FloatingLabelInput
              label="Address 1"
              value={state.userData["address_1"]}
              onChange={handleUserDataChange("address_1")}
            />
          </div>
        </Col>
        <Col>
          <div className="my-3">
            <FloatingLabelInput
              label="Address 2"
              value={state.userData["address_2"]}
              onChange={handleUserDataChange("address_2")}
            />
          </div>
        </Col>
      </Row>
      <Row>
        <Col>
          <div className="my-3">
            <FloatingLabelInput
              label="City"
              value={state.userData["city"]}
              onChange={handleUserDataChange("city")}
            />
          </div>
        </Col>
        <Col>
          <div className="my-3">
            <FloatingLabelInput
              label="State"
              value={state.userData["state"]}
              onChange={handleUserDataChange("state")}
            />
          </div>
        </Col>
        <Col>
          <div className="my-3">
            <FloatingLabelInput
              label="Postal Code"
              value={state.userData["postal_code"]}
              onChange={handleUserDataChange("postal_code")}
            />
          </div>
        </Col>
      </Row>
      <div className="d-flex justify-content-end">
        <Button
          className="my-3"
          onClick={handleSaveUser}
          disabled={state.loading}
        >
          {state.loading ? "Saving user..." : "Save user"}
        </Button>
      </div>
    </>
  );

  return (
    <Container>
      <h1 className="mb-4">OCR user import</h1>
      {isUserDataPresent ? userFields : fileUploader}
    </Container>
  );
};

export default OcrUserImport;